import Resources from "shared/actions/resourcesActions";

export default class MasterDataResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "master_data", `/api/v1/messaging/master_data`);
  }
}
